import { db } from "@/firebase";
import { Restaurant } from "@/model/entities";
import { collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, query, where } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

/**
 * Fetches the URL of a file stored in Firebase Storage.
 * @param path - The path to the file in Firebase Storage.
 * @returns The download URL of the file.
 */
export async function getFirebaseImageUrl(path: string): Promise<string> {
  const storage = getStorage();
  const fileRef = ref(storage, path);
  return await getDownloadURL(fileRef);
}

/**
 * Categories CRUD Operations
 */

export async function getRestaurantByUserId(
  userId: string
): Promise<Restaurant | null> {
  // Get a specific restaurant document by userId
  const restaurantDoc = doc(db, "restaurants", userId);
  const restaurantSnapshot = await getDoc(restaurantDoc);
  console.log("Restaurant snapshot:", restaurantSnapshot);
  if (restaurantSnapshot.exists()) {
    return {
      id: restaurantSnapshot.id,
      ...restaurantSnapshot.data(),
    } as Restaurant;
  } else {
    return null;
  }
}

export async function subscribeToRestaurantChanges(
  userId: string,
  callback: (restaurant: Restaurant | null) => void
) {
  const restaurantDoc = doc(db, "restaurants", userId);
  return onSnapshot(restaurantDoc, (doc) => {
    if (doc.exists()) {
      const restaurant = { id: doc.id, ...doc.data() } as Restaurant;
      callback(restaurant);
    } else {
      callback(null);
    }
  });
}

export async function fetchRestaurantBySubdomain(subdomain: string): Promise<Restaurant | null> {
  const restaurantsRef = collection(db, "restaurants");
  const q = query(restaurantsRef, where("subdomain", "==", subdomain));
  const snapshot = await getDocs(q);
  if (!snapshot.empty) {
    const doc = snapshot.docs[0];
    return { id: doc.id, ...doc.data() } as Restaurant;
  }
  return null;
}


// Create a new category with image upload
// export async function createCategory(
//   restaurantId: string,
//   categoryData: CategoryFormData,
//   order: number = 0
// ): Promise<Category> {
//   const categoriesRef = collection(
//     db,
//     "restaurants",
//     restaurantId,
//     "categories"
//   );

//   const newCategoryRef = doc(categoriesRef);
//   const newCategoryId = newCategoryRef.id;

//   const newCategory = { ...categoryData, order } as Category;

//   await setDoc(newCategoryRef, newCategory);
//   return { id: newCategoryId, ...newCategory };
// }

// // Get all categories for a restaurant
// export async function getCategories(restaurantId: string): Promise<Category[]> {
//   const categoriesRef = collection(
//     db,
//     "restaurants",
//     restaurantId,
//     "categories"
//   );
//   const snapshot = await getDocs(categoriesRef);
//   return snapshot.docs.map(
//     (doc) => ({ id: doc.id, ...doc.data() } as Category)
//   );
// }

// // Update a category with optional image upload
// export async function updateCategory(
//   restaurantId: string,
//   categoryId: string,
//   categoryData: CategoryFormData
// ) {
//   const categoryRef = doc(
//     db,
//     "restaurants",
//     restaurantId,
//     "categories",
//     categoryId
//   );
//   return await updateDoc(categoryRef, { ...categoryData });
// }

// // Delete a category
// export async function deleteCategory(
//   restaurantId: string,
//   categoryId: string
// ): Promise<boolean> {
//   try {
//     // Get reference to the category document
//     const categoryRef = doc(
//       db,
//       "restaurants",
//       restaurantId,
//       "categories",
//       categoryId
//     );

//     // Delete the document from Firestore
//     await deleteDoc(categoryRef);

//     return true;
//   } catch (error) {
//     console.error(`Error deleting category ${categoryId}:`, error);
//     throw error; // Rethrow to let caller handle the error
//   }
// }

// export async function deleteRestaurantWithBackend(restaurantId: string) {
//   const auth = getAuth();
//   const user = auth.currentUser;
//   if (!user) throw new Error("Not authenticated");
//   const idToken = await user.getIdToken();
//   const isTest = true;
//   const functionUrl = isTest
//     ? `http://127.0.0.1:5001/smrt-menu-e70b9/us-central1/api`
//     : `https://api-gmvvdl4ofa-uc.a.run.app`;
//   const response = await fetch(`${functionUrl}/restaurants/${restaurantId}`, {
//     method: "DELETE",
//     headers: {
//       Authorization: `Bearer ${idToken}`,
//     },
//   });
//   if (!response.ok) {
//     const errorText = await response.text();
//     throw new Error(errorText || "Failed to delete restaurant");
//   }
// }

export async function deleteUser(userId: string) {
  try {
    const userRef = doc(db, "users", userId);
    await deleteDoc(userRef);
  } catch (error) {
    console.error(`Error deleting user ${userId}:`, error);
    throw error; // Rethrow to let caller handle the error
  }
}
